import { Show } from 'solid-js';
import { useTheme } from '../theme/ThemeProvider';

/**
 * Aurora Background Component
 * Renders animated gradient layers and particles for aurora theme
 * Only visible when gradient-aurora theme is active
 */
export function AuroraBackground() {
  const theme = useTheme();

  return (
    <Show when={theme.preset() === 'gradient-aurora'}>
      <>
        {/* Aurora gradient layers */}
        <div class="aurora-layer aurora-layer--1" aria-hidden="true" />
        <div class="aurora-layer aurora-layer--2" aria-hidden="true" />
        <div class="aurora-layer aurora-layer--3" aria-hidden="true" />
        <div class="aurora-layer aurora-layer--4" aria-hidden="true" />

        {/* Floating particles */}
        <div class="aurora-particle aurora-particle--1" aria-hidden="true" />
        <div class="aurora-particle aurora-particle--2" aria-hidden="true" />
        <div class="aurora-particle aurora-particle--3" aria-hidden="true" />
        <div class="aurora-particle aurora-particle--4" aria-hidden="true" />
        <div class="aurora-particle aurora-particle--5" aria-hidden="true" />
        <div class="aurora-particle aurora-particle--6" aria-hidden="true" />

        {/* Noise texture */}
        <div class="aurora-noise" aria-hidden="true" />
      </>
    </Show>
  );
}
